import * as turf from '@turf/turf';
import type { OrganizationRegion } from '~/common/types';
import CA from './ca';

type RegionIdentifier = 'california';

const regions: { [Region in RegionIdentifier]: OrganizationRegion } = {
  california: CA,
};

export default regions;

type Geom = GeoJSON.Polygon | GeoJSON.MultiPolygon;

export function isWithinRegion(
  geometry: Geom,
  boundary: GeoJSON.Geometry = regions.california.region as GeoJSON.Geometry,
) {
  // turfJS's `booleanWithin` does not handle MultiPolygons,
  // so have to do this manually.
  const polygons: GeoJSON.Polygon[] = [];

  if (geometry.type === 'MultiPolygon') {
    geometry.coordinates[0].forEach((g) => {
      const p: GeoJSON.Polygon = {
        type: 'Polygon',
        coordinates: [g],
      };

      polygons.push(p);
    });
  } else {
    polygons.push(geometry);
  }

  const completelyWithin = polygons.every((p) => {
    if (turf.booleanWithin(p, boundary)) {
      return true;
    }

    return false;
  });

  return completelyWithin;
}
